import React from 'react';
import { Users, CheckCircle, AlertTriangle, FileText } from 'lucide-react';
import { motion } from 'framer-motion';

interface DebtorStatsProps {
  stats: {
    totalDebtors: number;
    activeDebtors: number;
    completeDocuments: number;
    incompleteDocuments: number;
    totalDocuments: number;
  };
}

export default function DebtorStats({ stats }: DebtorStatsProps) {
  const statCards = [
    {
      label: 'Total Debitur',
      value: stats.totalDebtors,
      subtext: `${stats.activeDebtors} aktif`,
      icon: Users,
      color: 'amber',
      borderColor: 'border-l-amber-500',
      bgColor: 'bg-amber-50',
      textColor: 'text-amber-600',
    },
    {
      label: 'Dokumen Lengkap',
      value: stats.completeDocuments,
      subtext: 'siap diproses',
      icon: CheckCircle,
      color: 'green',
      borderColor: 'border-l-green-500',
      bgColor: 'bg-green-50',
      textColor: 'text-green-600',
    },
    {
      label: 'Dokumen Tidak Lengkap',
      value: stats.incompleteDocuments,
      subtext: 'perlu dilengkapi',
      icon: AlertTriangle,
      color: 'yellow',
      borderColor: 'border-l-yellow-500',
      bgColor: 'bg-yellow-50',
      textColor: 'text-yellow-600',
    },
    {
      label: 'Total Dokumen',
      value: stats.totalDocuments,
      subtext: 'tersimpan',
      icon: FileText,
      color: 'blue',
      borderColor: 'border-l-blue-500',
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-600',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {statCards.map((card, index) => (
        <motion.div
          key={card.label}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
        >
          <div
            className={`bg-white rounded-lg border shadow-sm border-l-4 ${card.borderColor} p-4`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">{card.label}</p>
                <p className="text-2xl font-bold">{card.value}</p>
                <p className={`text-xs ${card.textColor} mt-1`}>{card.subtext}</p>
              </div>
              <div
                className={`w-12 h-12 rounded-xl ${card.bgColor} flex items-center justify-center`}
              >
                <card.icon className={`w-6 h-6 ${card.textColor}`} />
              </div>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
